import { render, staticRenderFns } from "./Original.vue?vue&type=template&id=09a7498d&"
import script from "./Original.vue?vue&type=script&lang=js&"
export * from "./Original.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports